 
export const transformUnicode10to16 = (text: string): string => {
  const input = text || '';
  const matches = input.match(/&#\d{4};/g);
  if (!matches) {
    return text;
  }

  let result = input;
  matches.forEach(match => {
    const codeStr = match.replace(/[&#;]/g, '');
    const code = parseInt(codeStr, 10);
    if (!Number.isNaN(code)) {
      result = result.replace(match, String.fromCharCode(code));
    }
  });

  return result;
}

export default transformUnicode10to16;
